import React from 'react';
import { FieldHookConfig, useField } from 'formik';

import * as Types from '../types';

import Field from '../Field';

import classes from '../Field.module.scss';

interface IProps extends Types.FieldProps {
  htmlType?: 'text' | 'password';
}

const Text: React.FC<IProps> = ({ placeholder, maxLength, showError = true, disabled, readOnly, htmlType = 'text', ...props }) => {
  const [field, meta] = useField(props as FieldHookConfig<any>);

  const hasError = !!(showError && meta.touched && meta.error);

  return (
    <Field {...{ hasError, error: meta.error, disabled, readOnly, ...props }}>
      {({ onFocus, onBlur }) => (
        <input
          {...field}
          {...{ placeholder, maxLength, disabled, onFocus, readOnly }}
          id={field.name}
          value={field.value || ''}
          type={htmlType}
          className={classes.input}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          onBlur={(e) => {
            field.onBlur(e);
            onBlur();
          }}
        />
      )}
    </Field>
  );
};

export default Text;